import React from "react";
import './button.css'
import { color } from "../../utils/themes/color";
import LOADING from "../loading/loading";



export default function BUTTON(props) {

    switch (props.type) {
        case "submit": switch (props.loading) {
            case true: return <button
                className="primary_button"
                style={{ color: color.primaryContainer, cursor: "wait" }}
                onChange={(e) => props.event(e)}>
                <LOADING color={color.primaryContainer}/>
            </button>
            default:
                return <button
                    className="primary_button"
                    style={{ color: color.primaryContainer }}
                    onClick={(e) => props.event(e)}>{props.text}</button>
        }

        case "cancel": switch (props.loading) {
            case true: return <button
                className="primary_button"
                style={{ color: color.error, cursor: "wait" }}
                onChange={(e) => props.event(e)}>
                <LOADING color={color.error}/>
            </button>
            default:
                return <button
                    className="primary_button"
                    style={{ color: color.error }}
                    onClick={(e) => props.event(e)}>{props.text}</button>
        }



        default: switch (props.loading) {
            case true: return <button
                className="primary_button"
                style={{ color: color.primary, cursor: "wait" }}
                onChange={(e) => props.event(e)}>
                <LOADING color={color.primary}/>
            </button>
            default:
                return <button
                    className="primary_button"
                    style={{ color: color.primary }}
                    onClick={(e) => props.event(e)}>{props.text}</button>
        }
    }
}